module.exports = __webpack_public_path__ + "static/media/BRN.b4665d38.png";